export default "__VITE_ASSET__BwcQS1JA__"